import { render, staticRenderFns } from "./SupportTile.vue?vue&type=template&id=24f51ae0&scoped=true&lang=pug&"
import script from "./SupportTile.vue?vue&type=script&lang=js&"
export * from "./SupportTile.vue?vue&type=script&lang=js&"
import style0 from "./SupportTile.vue?vue&type=style&index=0&id=24f51ae0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f51ae0",
  null
  
)

export default component.exports